export default __webpack_public_path__ + "static/media/news248101.ae9e2311.webp";